import React from "react";

// Arrow_Left component accepts a 'color' prop to define the color of the arrow
const ArrowLeft = ({ color }) => {
  return (
    <div className="arrow-left">
      <svg
        xmlns="http://www.w3.org/2000/svg" // XML namespace for SVG
        width="44.1" // Width of the SVG
        height="13.325" // Height of the SVG
        viewBox="0 0 44.1 13.325" // Viewbox for scaling the SVG
      >
        <g id="arrow" transform="translate(-9.413 11.911) rotate(180)">
          {/* Grouping the elements for transformations, rotated 180 degrees */}
          <line
            id="Línea_1" // Unique ID for the line
            data-name="Línea 1" // Name for the line, used for accessibility
            x2="42.1" // Length of the line
            transform="translate(-52.513 4.698)" // Positioning the line in the SVG
            fill="none" // No fill color for the line
            stroke={color} // Stroke color set by the color prop
            strokeLinecap="round" // Rounded ends for the line
            strokeWidth="2" // Width of the stroke
          />
          <path
            id="Trazado_7679" // Unique ID for the path
            data-name="Trazado 7679" // Name for the path, used for accessibility
            d="M6904,3501.6l4.785,4.785L6904,3512.1" // Path definition for the arrowhead
            transform="translate(-6919.198 -3501.6)" // Positioning the path in the SVG
            fill="none" // No fill color for the path
            stroke={color} // Stroke color set by the color prop
            strokeLinecap="round" // Rounded ends for the stroke
            strokeLinejoin="round" // Rounded corners for the path
            strokeWidth="2" // Width of the stroke
          />
        </g>
      </svg>
    </div>
  );
};

export default ArrowLeft; // Exporting the component for use in other files
